import * as yup from "yup";

const alta = yup.object().shape({
    datosGenerales: yup.object({
        nombre: yup.string()
            .transform(value => value === null || value === undefined ? '' : value)
            .required("El nombre es requerido")
            .min(1, "El nombre es requerido"),
        apellidoPaterno: yup.string()
            .transform(value => value === null || value === undefined ? '' : value)
            .required("El apellido paterno es requerido")
            .min(1, "El apellido paterno es requerido"),
        rfc: yup.string()
            .transform(value => value === null || value === undefined ? '' : value)
            .required("El RFC es requerido")
            .min(1, "El RFC es requerido"),
        telefonoPersonal: yup.string().nullable(),
        telefonoABC: yup.string()
            .transform(value => value === null || value === undefined ? '' : value)
            .required("Es requerido un número de teléfono")
            .min(1, "Es requerido un número de teléfono")
    }),
    licencias: yup.array().of(
        yup.object({
            numeroDocumento: yup.string()
                .transform(value => value === null || value === undefined ? '' : value)
                .required("El numero de licencia es requerido")
                .min(1, "El numero de licencia es requerido"),            
            vigencia: yup.date()
                .transform(value => value === null || value === undefined ? '' : value)
                .required("La vigencia es requerida")
        })
    )
});
 
const permValidacionEsquema = {
    alta
};

export default permValidacionEsquema;